import { IYxInputPropTypes } from "./basePropType";
export const IEmailPropTypes = {
  ...IYxInputPropTypes,
};

export const eamilDefaultProps = () => ({
  rules: {},
  inputParam: {},
  children: "",
  styleParam: {
    width: "sm", //宽度  xxs,xs,sm,md,lg,xl
    size: "default", //大小
    type: "default", //类型
  },
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/emailPropType.js